export default "__VITE_ASSET__DFHUR3cN__"